import React from 'react';

import CardGrid from './CardGrid';
import Section from './Section';
import SectionHero from '../components/SectionHero';

const RelatedContent = ({ relatedContent: entries }) => {
  if (!entries || !entries.length) return null;

  return (
    <Section colour="light" size="small">
      <SectionHero noHr title="Related" />
      <CardGrid entries={entries} />
    </Section>
  );
};

export default RelatedContent;
